<template>
    <div class="ticker-feed" :class="{'ticker-feed--live': live}">
        <data-loader :url="`/v1/events/${event.id}/ticker-messages`"
                   on-scroll
					 as-guest
                   ref="loader"
                   :scroll-load-margin="500"
                   v-model:data="messages">

            <template v-if="editable" #alwaysshow>
                <lazy-ticker-message-form :event="event" @created="handleCreatedMessage"/>
            </template>

            <template #loading>
                <ticker-message-skeleton v-for="loaderIndex in 4" :key="'message-loader-' + loaderIndex"/>
            </template>

            <template v-slot="{data}">
				<template v-for="message in data" :key="message.id">
					<ticker-message :message="message" @edit="editMessage(message)" @destroyed="handleRemovedMessage(message)" :editable="editable"/>
				</template>
			</template>

            <template #missing>
                <ticker-message :message="missingMessage"/>
            </template>
        </data-loader>

        <ajax-form-modal v-if="editData" v-model="showEditMessageModal"
                         :form-options="{action: `/v1/events/${event.id}/ticker-messages/${editData.id}`, data: editData, method: 'PUT'}"
                         :modal-options="{title: $t('action.edit')}"
                         :submit-text="$t('action.save')"
                         @success="handleUpdatedMessage">

            <ticker-message-form-inputs :data="editData" edit/>

        </ajax-form-modal>

    </div>
</template>

<script>
export default {
    name: "TickerFeed",

    props: {
        event: {
            type: Object,
            required: true
        },

        editable: {
            type: Boolean,
            default: false
        },

        // Whether the ticker might receive a new message within the next time
        live: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            messages: [],
            showEditMessageModal: false,
            editData: {},
            missingMessage: {
                message: this.$t('missing.ticker_messages.index')
            }
        }
    },

    mounted() {
        this.$nextTick(function () {
            this.activateLiveUpdates();
        });
    },

    beforeUnmount() {
        this.disableLiveUpdates();
    },

    methods: {
        editMessage(message) {
            this.editData = {
                id: message.id,
                title: message.title,
                category: message.category.value,
                message: message.message,
                image: message.image,
            };
            this.$nextTick(function () {
                this.showEditMessageModal = true;
            });
        },

        handleCreatedMessage(message) {
            this.messages.splice(0, 0, message);
        },

        handleUpdatedMessage(message) {
            const index = this.messages.findIndex(m => m.id === message.id);
            if (index > -1) {
                this.messages[index] = message
            }
        },

        handleRemovedMessage(message) {
            const index = this.messages.findIndex(m => m.id === message.id);
            if (index > -1) {
                this.messages.splice(index, 1);
            }
        },

        activateLiveUpdates() {
            console.log('Listening for live ticker updates...');
            this.$echo.subscribe('event.' + this.event.id)
                .listen('ticker_message.created', (data) => {
                    this.handleCreatedMessage(data);
                }, false)
                .listen('ticker_message.updated', (data) => {
                    this.handleUpdatedMessage(data);
                }, false)
                .listen('ticker_message.deleted', (data) => {
                    this.handleRemovedMessage(data);
                }, false);
        },

        disableLiveUpdates() {
            console.log('Stop listening for updates on live ticker.');
            this.$echo.unsubscribe('event.' + this.event.id);
        },
    }
}
</script>

<style>
/*********************
  Inputs
**********************/
.ticker-feed {
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  padding-left: 32px;
  border-left: 2px solid #e6ecf5;
}
@media (max-width: 639px) {
  .ticker-feed {
    margin-top: 8px;
    margin-left: 8px;
  }
}
</style>